import React from "react";

const VillaLocationIcon = () => {
  return (
    <>
      <svg
        width="16px"
        height="18px"
        viewBox="0 0 16 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M2.29033 0C1.02743 0 0 1.02746 0 2.29033C0 3.5532 1.02743 4.58066 2.29033 4.58066C3.55324 4.58066 4.58066 3.5532 4.58066 2.29033C4.58066 1.02746 3.5532 0 2.29033 0Z"
            transform="translate(5.304705 5.00255)"
            fill="#343738"
            stroke="none"
          />
          <path
            d="M12.9386 2.21991C11.5071 0.788375 9.60372 0 7.57925 0C5.55478 0 3.65145 0.788375 2.21994 2.21991C0.788375 3.65148 0 5.55478 0 7.57922C0 11.6747 3.8724 15.081 5.9528 16.9111C6.24187 17.1654 6.49152 17.385 6.69036 17.5707C6.93959 17.8036 7.25935 17.92 7.57922 17.92C7.89905 17.92 8.21887 17.8036 8.46808 17.5708C8.66698 17.385 8.9166 17.1654 9.20567 16.9111C11.2861 15.0811 15.1585 11.6747 15.1585 7.57925C15.1585 5.55478 14.3701 3.65148 12.9386 2.21991ZM7.57925 10.6329C5.73751 10.6329 4.2392 9.13458 4.2392 7.29284C4.2392 5.45111 5.73751 3.9528 7.57925 3.9528C9.42098 3.9528 10.9193 5.45111 10.9193 7.29284C10.9193 9.13458 9.42095 10.6329 7.57925 10.6329Z"
            transform="translate(0.015785 0)"
            fill="#FC8919"
            stroke="none"
          />
        </g>
      </svg>
    </>
  );
};

export default VillaLocationIcon;
